<template>
  <div ref="dropdown" class="multiselect-checkbox text-grayDark font-normal" :class="{ 'is-disabled': disabled }">
    <div
      v-if="!showList"
      :class="`${isDropdownOpen ? 'border-primary' : 'border-grayLight'} ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`"
      class="multiselect-checkbox__dropdown select-none px-2 border rounded-md flex items-center justify-between h-5"
      @click="isDropdownOpen = !isDropdownOpen"
    >
      {{ placeholderData }}
      <i class="font-bold text-bordersDark" :class="`el-icon-arrow-${isDropdownOpen ? 'up' : 'down'}`"></i>
    </div>

    <div v-if="showList || isDropdownOpen" class="multiselect-checkbox__options-list">
      <div class="multiselect-checkbox__search flex items-center gap-1 px-2 h-5 border border-grayLight rounded mb-2" @click.stop="$refs.searchInput.focus()">
        <i class="el-icon-search text-bordersDark text-15px font-bold"></i>
        <input
          ref="searchInput"
          v-model="searchQuery"
          type="text"
          class="flex-1 focus:outline-none placeholder-grayDark w-full"
          placeholder="Search..."
          @click.stop
          @keydown.stop
        />
      </div>
      <el-scrollbar>
        <div class="multiselect-checkbox__grid">
          <div v-for="option in filteredOptions" :key="option.value" class="multiselect-checkbox__option-item">
            <label class="flex items-center cursor-pointer">
              <input v-model="selectedOptions" class="hidden multiselect-checkbox__input" type="checkbox" :value="option" />
              <span class="multiselect-checkbox__custom-checkmark rounded-sm mr-1 inline-flex items-center text-white"
                ><i class="el-icon-check font-bold"></i
              ></span>
              {{ option.label }}
            </label>
          </div>
        </div>
        <div v-if="filteredOptions.length === 0" class="text-grayDark text-sm py-1 px-1">No results found</div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiselectCheckbox',
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'Select options',
    },
    showList: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      selectedOptions: this.value,
      searchQuery: '',
    }
  },
  computed: {
    filteredOptions() {
      if (!this.searchQuery) return this.options
      const q = this.searchQuery.toLowerCase()
      return this.options.filter((o) => o.label.toLowerCase().includes(q))
    },
    placeholderData() {
      if (this.selectedOptions.length === 0) {
        return this.placeholder
      } else if (this.selectedOptions.length >= 4) {
        return `${this.selectedOptions.length} selected`
      } else {
        return this.selectedOptions.map((item) => item.label).join(', ')
      }
    },
  },
  watch: {
    selectedOptions(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.selectedOptions = newValue
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      if (this.isDropdownOpen && !this.$el.contains(event.target)) {
        this.isDropdownOpen = false
        this.searchQuery = ''
      }
    },
  },
}
</script>

<style lang="scss">
.multiselect-checkbox {
  &.is-disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
  &__custom-checkmark {
    border: 2px solid theme('colors.bordersDark');
    transition: all 0.3s;
    i {
      opacity: 0;
      transition: opacity 0.3s;
    }
  }
  &__input:checked + .multiselect-checkbox__custom-checkmark {
    background-color: theme('colors.primary');
    border-color: theme('colors.primary');
    i {
      opacity: 1;
    }
  }
  // &__options-list {
  //   position: absolute;
  //   z-index: 1000;
  //   background-color: theme('colors.white');
  //   border: 1px solid theme('colors.bordersDark');
  //   border-radius: 4px;
  //   width: 100%;
  //   max-height: 200px;
  //   overflow-y: auto;
  //   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  //   margin-top: 5px;
  // }
  el-scrollbar {
    overscroll-behavior: contain;
  }
  &__grid {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 4px 0;
  }
}
</style>
